const texts = {
  mainHeadline: {
    headline: "Custom, timeless, and elegant events that will never be forgotten",
    description: `We are confident, capable, and responsive event planners and designers who understand your 
    needs and exceed your expectations ensuring that each and every event is thoughtfully produced and curated 
    to create a moment that forges life long impressions. Our ultimate goal is for you to enjoy the planning 
    process as much as the actual event itself.`
  },
  inquireHeadline: {
    headline: "Seeking a custom-curated experience beyond compare?",
    description: `Let us curate an extraordinary occasion designed entirely around your vision.`
  },
  contactHeadline: {
    headline: "Seeking a custom-curated experience beyond compare? Connect With Us.",
    description: `Let us curate an extraordinary occasion designed entirely around your vision.`
  },
  ourExpertise: {
    headline: "Our Expertise",
    description: `We specialize in creating unforgettable events across personal, corporate, community, 
    and destination categories. From weddings, milestone birthdays, anniversaries, and family reunions, 
    to conferences, product launches, team-building activities, and charity galas, we handle every 
    detail — venue selection, décor, catering, guest coordination, and more — ensuring seamless, personalized 
    experiences that reflect your vision. Our expertise also extends to destination weddings and corporate 
    retreats, thoughtfully managing travel, accommodations, and on-site activities to deliver flawless events 
    anywhere your dreams take you.`
  },
  weddingService: {
    headline: "Weddings",
    description: `Your wedding is one of the most important days of your life, and we are here to make it nothing 
    short of extraordinary. From the very first consultation, our team works closely with you to understand your 
    vision, your style, and your story. We take care of every detail—venue selection, décor design, catering, 
    entertainment, guest coordination, and timeline management—so you can focus on the joy of the moment. Whether 
    you dream of an intimate gathering or a grand celebration, we bring your vision to life with creativity, 
    precision, and passion.`
  },
  socialEventsService: {
    headline: "Social Events",
    description: `For social events, we bring life’s most important moments to perfection. From milestone birthday 
    celebrations that reflect personality and style, we make sure every occasion feels extraordinary. Anniversaries
    that are crafted with care, whether it’s an intimate dinner or a lively family gathering, while baby showers and 
    gender reveals are infused with joy through themed decorations and engaging activities.`
  },
  corporateEventsService: {
    headline: "Corporate Events",
    description: `When it comes to corporate events, we deliver professionalism and impact. Our team organizes conferences 
    and seminars with precision, handling venue booking, audio-visual equipment, and speaker coordination. Product launches 
    are designed to stand out, with staging, branding, and PR support that ensures maximum visibility. Team-building events 
    are carefully planned with tailored activities, catering, and schedules that strengthen collaboration, while award 
    ceremonies are executed with polished scripts, stage design, and guest management. We also create festive holiday parties 
    with décor, entertainment, and dining experiences that leave lasting impressions on employees and clients alike.`
  },
  communityService: {
    headline: "Community & Nonprofit",
    description: `We are equally passionate about serving communities and nonprofit organizations. From fundraisers and charity 
    galas, where we coordinate auctions and donor engagement, to large-scale festivals and fairs that require permits, vendor 
    management, and security, we bring structure and creativity to events that make a difference. Cultural events are celebrated 
    with performances, catering, and logistics that bring people together while honoring tradition.`
  },
  destinationService: {
    headline: "Travel & Destination",
    description: `We create stunning destination weddings, taking care of venues, guest accommodations, and travel arrangements 
    for seamless celebrations abroad. Corporate and wellness retreats are designed to balance work, relaxation, and enrichment, 
    with carefully chosen hotels, activities, and schedules. For incentive trips, we craft bespoke travel experiences that reward 
    employees or impress clients, turning recognition into unforgettable journeys.`
  }
};

export default texts;
